/**
 * RLE + base64 codec for the area-map `walk` mask. Uses the global
 * `btoa`/`atob` (browsers and Node >= 16), never Buffer.
 */
export function bytesToBase64(bytes) {
    let s = '';
    const CHUNK = 0x8000;
    for (let i = 0; i < bytes.length; i += CHUNK) {
        s += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
    }
    return btoa(s);
}
export function base64ToBytes(b64) {
    const s = atob(b64);
    const out = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i++)
        out[i] = s.charCodeAt(i);
    return out;
}
/** Encodes cells as (runLength 1..255, value) pairs, then base64. */
export function encodeRle(cells) {
    const out = [];
    let i = 0;
    while (i < cells.length) {
        const v = cells[i];
        let run = 1;
        while (run < 255 && i + run < cells.length && cells[i + run] === v)
            run++;
        out.push(run, v);
        i += run;
    }
    return bytesToBase64(Uint8Array.from(out));
}
/** Decodes `encodeRle` output; throws unless it yields exactly `expectedLength` cells. */
export function decodeRle(b64, expectedLength) {
    const pairs = base64ToBytes(b64);
    if (pairs.length % 2 !== 0)
        throw new Error('walk: odd RLE byte count');
    const out = new Uint8Array(expectedLength);
    let o = 0;
    for (let i = 0; i < pairs.length; i += 2) {
        const run = pairs[i];
        const v = pairs[i + 1];
        if (run === 0)
            throw new Error('walk: zero-length RLE run');
        if (o + run > expectedLength)
            throw new Error(`walk: RLE overflows ${expectedLength} cells`);
        out.fill(v, o, o + run);
        o += run;
    }
    if (o !== expectedLength)
        throw new Error(`walk: RLE decodes ${o} cells, expected ${expectedLength}`);
    return out;
}
